// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__36Zeb","detailsBorder":"styles_detailsBorder__1uW6J"};